import React, { useState } from 'react'
import _ from 'lodash'
import { Row, Col, Avatar, Upload, Modal } from 'antd'
import moment from 'moment'

import SystemUserAvatar from './SystemUserAvatar'
import UserAvatar from './UserAvatar'
import ConstituentAvatar from './ConstituentAvatar'
import TakePhoto from './TakePhoto'

const AvatarUpload = (props) => {
	const { 
		onChange, 
		system_user_uid, 
		user_uid,
		constituent_uid,
		...rest
	} = props

	const [previewImage, setPreviewImage] = useState(null)
	const [isModalShown, setModalShown] = useState(false)
	const [isTakePhotoShown, setTakePhotoShown] = useState(false)

	const handlePreview = async (file) => {
		setModalShown(false)
		if (file) {
			if (!file.url && !file.preview) {
				file.preview = await getBase64(file.originFileObj)
			}
			setPreviewImage(file.url || file.preview)
		}
	}

	const getBase64 = (file) => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = () => resolve(reader.result)
			reader.onerror = error => reject(error)
		})
	}

	const handleImageBase64ToFileObject = (imageBase64) => {
		return new Promise((resolve, reject) => {
			const filename = `${moment().format('YYYYMMDDHHmmss')}_photoFromCamera.png`
			const bstr = window.atob(imageBase64.split(',')[1])
			let n = imageBase64.length
			const u8arr = new Uint8Array(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			const file = new File([u8arr], filename, { type: 'image/png' })
			resolve(file)
		})
	}

	const fileProps = Object.assign({}, rest, {
		name: 'file',
		multiple: false,
		onChange(info) {
			console.log('info', info)
			if (info.fileList.length > 0) {
				handlePreview(info.fileList[info.fileList.length - 1])
			}
			if (onChange) onChange(info)
		},
		beforeUpload (file, fileList) { return false },
		showUploadList: false,
		accept: 'image/jpeg, image/png'
	})

	return (
		<div style={{ display: 'inline-flex' }}>
			{
				(previewImage || (!system_user_uid && !user_uid && !constituent_uid)) &&
				<Avatar src={previewImage} icon="user" size={120} />
			}
			{
				system_user_uid && !previewImage &&
				<SystemUserAvatar user_uid={system_user_uid} icon="user" size={120} />
			}
			{
				user_uid && !previewImage &&
				<UserAvatar user_uid={user_uid} icon="user" size={120} />
			}
			{
				constituent_uid && !previewImage &&
				<ConstituentAvatar constituent_uid={constituent_uid} icon="user" size={120} />
			}
			<div className='camera-icon-container' onClick={() => setModalShown(true)}>
				<img className='camera-icon-avatar' width='20' height='auto' src='/assets/images/icons/add_image.svg' alt='Update Avatar'/>
			</div>
			{
				isModalShown &&
				<Modal
					title='Update Photo'
					visible={isModalShown}
					onCancel={() => setModalShown(false)}
					footer={null}
				>
					<Row>
						<Col md={12} sm={24} style={{ textAlign: 'center' }}>
							<Upload {...fileProps}>
								<button className='btn btn-primary btn-rounded waves-effect waves-light'>Upload From File</button>
							</Upload>
						</Col>
						<Col md={12} sm={24} style={{ textAlign: 'center' }}>
							<button className='btn btn-primary btn-rounded waves-effect waves-light' onClick={() => {
								setModalShown(false)
								setTakePhotoShown(true)
							}}>Take Photo</button>
						</Col>
					</Row>
				</Modal>
			}
			{
				isTakePhotoShown &&
				<TakePhoto 
					visible={isTakePhotoShown}
					onCancel={() => setTakePhotoShown(false)}
					onCapture={async (imageBase64) => {
						setTakePhotoShown(false)
						setPreviewImage(imageBase64)

						const fileObject = await handleImageBase64ToFileObject(imageBase64)
						const fileList = []
						fileList.push({ originFileObj: fileObject })
						onChange({ fileList })
					}}
				/>
			}
		</div>
	)
}

export default AvatarUpload